import { useTranslation } from "@nova/use-translation"
import Image from "next/image"
import { ReturnToWorkspaceButton } from "themes/default-tailwind/buttons/ReturnToWorkspaceButton"

export default function Page404() {
    const { t } = useTranslation()

    return (
        <div className="nova-center-screen-container">
            <div className="nova-error-container">
                <Image
                    src="/images/logos/nova-logo-with-title.svg"
                    alt="Nova"
                    width={150}
                    height={0}
                    className="nova-logo-title"
                    priority={true}
                />
                <h1 className="nova-error-header">{t("We've gotten lost")}</h1>
                <h5 className="text-gray-100 mb-5">
                    {t("The page you're looking for doesn't exist. Retrace your steps.")}
                </h5>
                <div className="flex gap-5 justify-center items-center">
                    <ReturnToWorkspaceButton />
                    <a className="text-gray-100 no-underline" href="mailto:support@mapnova.com">
                        {t("Contact Support")}
                    </a>
                </div>
            </div>
        </div>
    )
}
